import { useEffect } from 'react';

export const usePageTitle = (props) => {
  const ucFirst = (title) => title[0].toUpperCase() + title.slice(1);

  useEffect(() => {
    document.title = ucFirst(props.resource ? props.resource : 'React App');
  });
};
